import { useTranslation } from "react-i18next";
import { USER_TABLE } from "./config/user-management-table";
import { UserService } from "../../services";
import { toast } from "react-toastify";
import { useState } from "react";
import CreateUserModal from "./CreateUserModal";

const UserManagementTable = ({ currentTab, loading, users, getUsersList }) => {
  const { t } = useTranslation("common");
  const [showEditModal, setShowEditModal] = useState(0);

  const filteredList = USER_TABLE.filter((column) =>
    column.isForTab.includes(currentTab)
  );

  function handleDeleteClick(user) {
    UserService.markUserInactive({ user_id: user.id })
      .then((response) => {
        if (response.data.status === 200) {
          toast.success("User deleted successfully");
          getUsersList();
        } else {
          throw response.data;
        }
      })
      .catch((err) => toast.error(err.message));
  }

  function handleEditClick(user) {
    if (showEditModal) {
      document.body.classList.remove("overflow-hidden");
    } else {
      document.body.classList.add("overflow-hidden");
    }
    setShowEditModal(user?.id || 0);
  }

  return (
    <div>
      <div className="data-table">
        <table>
          <thead>
            <tr>
              {filteredList.map((column) => (
                <th key={column.id}>{column.headerValue(t)}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {!loading && users.length ? (
              users.map((user) => (
                <tr key={user.id}>
                  {filteredList.map((column) => (
                    <td key={column.id}>
                      {column.dataValue(
                        user,
                        handleDeleteClick,
                        handleEditClick
                      )}
                    </td>
                  ))}
                </tr>
              ))
            ) : loading ? (
              <tr>
                <td>&nbsp;</td>
              </tr>
            ) : (
              <tr>
                <td
                  colSpan={filteredList.length}
                  style={{ textAlign: "center" }}
                >
                  No Data Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {showEditModal ? (
        <CreateUserModal
          showAddUserModal={showEditModal}
          handleAddUserClick={handleEditClick}
          getUsersList={getUsersList}
          user={users.find((user) => user.id === showEditModal)}
        />
      ) : null}
    </div>
  );
};

export default UserManagementTable;
